import styles from './PartnerHowItWorks.module.css';

const STEPS = [
  {
    title: 'Create your free account',
    body: 'Sign up in under a minute and get your personal referral link instantly.',
  },
  {
    title: 'Share your link',
    body: 'Post it on Instagram, TikTok, YouTube, or send it directly to your audience.',
  },
  {
    title: 'Earn on every install',
    body: 'You earn $0.10 for each verified app install driven through your link.',
  },
  {
    title: 'Get paid monthly',
    body: 'Track clicks, installs, and earnings in your dashboard.',
  },
];

export function PartnerHowItWorks() {
  return (
    <section className={styles.section} aria-labelledby="partner-how-it-works">
      <h2 id="partner-how-it-works" className={styles.title}>
        How it works
      </h2>
      <p className={styles.subtitle}>
        No upfront cost. Share LuvLust with couples who want better date nights — and earn as they
        install.
      </p>
      <ol className={styles.steps}>
        {STEPS.map((step, index) => (
          <li key={step.title} className={styles.step}>
            <span className={styles.stepNumber}>{index + 1}</span>
            <div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepBody}>{step.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
